import { addMainImageUrl } from "../constants/urls";
import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { convertFormData } from "@/business/shared/commons/rest/convertToFormData";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { AddMainImageRequest } from "../../domain/inventory";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const addMainImageService = {
    async execute(token: string, addMainImageRequest: AddMainImageRequest): Promise<void> {
        const url = getEnvVariable
            .execute("VUE_APP_DACCACH_URL")
            .concat(addMainImageUrl);

        const formData = convertFormData(addMainImageRequest);

        const headers = {
            "web-token": token,
            Accept: "application/json",
        };

        const response: RestResponse = await restClient().sendRequest(
            url,
            "POST",
            formData,
            headers
        );

        if (!response.isSuccess) {
            const errorMessage =
                response.statusCode == 422
                    ? DaccachErrorActions().extractFormError(response.content)
                    : response.content;
            throw DaccachErrorActions().createError(errorMessage);
        }
    },
};
